import styled from 'styled-components'

export const Annotation = styled.div<{
    align?: 'left' | 'right' | 'center'
    colorMode?: 'light' | 'dark'
  }>`
    font-family: var(--font-sans-serif);
    font-size: 16px;
    line-height: 20px;
    color: #474a66;
    color: ${({ colorMode }) =>
      colorMode && colorMode === 'dark' ? '#fff' : '#474a66'};
  
    padding: 5px;
    text-align: ${({ align = 'left' }) => align};
    transform: ${({ align = 'left' }) =>
      align === 'right'
        ? 'translate(calc(-100% + 6px),0%)'
        : 'translate(-6px,0)'};
  
    @media only screen and (max-width: 831px) {
      font-size: 13px;
      line-height: 17px;
    }
    @media only screen and (max-width: 542px) {
      font-size: 12px;
      line-height: 16px;
      background-color: var(--site-background);
    }
  
    small {
      margin-top: 2px;
      display: inline-block;
      font-size: 12px;
      line-height: 16px;
      color: ${({ colorMode }) =>
        colorMode && colorMode === 'dark' ? '#fff' : '#6f7187'};
    }
    sup {
      font-size: 14px;
      @media only screen and (max-width: 831px) {
      font-size: 11px;
    }
      @media only screen and (max-width: 542px) {
        font-size: 11px;
      }
    }
    span {
      
      color: ${({ colorMode }) =>
        colorMode && colorMode === 'dark' ? '#fff' : '#202346'};
  
      font-weight: 700;
      font-size: 16px;

      @media only screen and (max-width: 831px) {
      font-size: 15px;
      line-height: 18px;
    }

      @media only screen and (max-width: 542px) {
        font-size: 13px;
        line-height: 16px;
      }
    }
  `